import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3305ff17"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "attachment-info" }
const _hoisted_3 = { class: "attachment-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-paperclip",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_5 = { class: "file-name" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-download" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times-circle" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "attachment-icon" }
const _hoisted_14 = { class: "attachment-info" }
const _hoisted_15 = { class: "attachment-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-paperclip",
  style: {"margin-right":"3px"}
}, null, -1))
const _hoisted_17 = { class: "file-name" }
const _hoisted_18 = ["accept"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "attachment-box",
        style: {"float":"left","margin":"0 5px 5px 0","background":"#ffffff"}
      }, [
        ($options.getFileIcon(item.ext) != 'fa fa-image-o')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["attachment-icon", $options.getFileIcon(item.ext)])
            }, null, 2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.localUrls[index] || item.url,
              style: {"width":"100%","height":"100px","object-fit":"contain"}
            }, null, 8, _hoisted_1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.fileName), 1),
            _createElementVNode("div", {
              class: "file-download",
              style: {"line-height":"14px"},
              onClick: $event => ($options.downloadEvent(item))
            }, _hoisted_8, 8, _hoisted_6),
            _createElementVNode("div", {
              onClick: $event => ($options.deleteEvent(item))
            }, _hoisted_11, 8, _hoisted_9)
          ])
        ])
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("div", {
      id: _ctx.id,
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "data-trigger": "manual",
      class: "attachment-box add",
      style: {"float":"left","margin-right":"5px"},
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.uploadEvent && $options.uploadEvent(...args)))
    }, [
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.loading ? _ctx.progress + '%' : '+'), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, "上传文件限" + _toDisplayString($props.maxSize) + "M以下", 1)
        ])
      ]),
      _createElementVNode("input", {
        type: "file",
        style: {"display":"none"},
        accept: $props.accept,
        multiple: ""
      }, null, 8, _hoisted_18)
    ], 8, _hoisted_12), [
      [_vShow, _ctx.files.length < $props.maxCount]
    ])
  ]))
}